import BaseService from './BaseService';

export default class EnumService extends BaseService {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'enum';
        this.getEnumList = this.getEnumList.bind(this);
        this.getEnumLabel = this.getEnumLabel.bind(this);
    }

    getEnumList(enumName, translate) {
        return this.fetch(`${this.domain}/${this.path}/list/${enumName}`, {
            method: 'GET',
        }).then((res) => {
            const result = [];
            if (res && translate) {
                res.forEach((element) => {
                    result.push({label: translate(`${enumName}.${element}`), enumValue: element});
                });
            }
            return Promise.resolve(result);
        });
    }

    getLocalizedEnumListForLocale(enumName) {
        return this.fetch(`${this.domain}/${this.path}/list/${enumName}/localized`, {
            method: 'GET',
        }).then((res) => {
            const result = [];
            res.values.forEach((el) => {
                result.push({label: el.label, enumValue: el.value});
            });
            return Promise.resolve(result);
        });
    }

    getLocalizedEnumList(enumName) {
        return this.fetch(`${this.domain}/${this.path}/list/${enumName}/localized/all`, {
            method: 'GET',
        }).then((res) => {
            let newArray = Object.entries(res);
            let map = new Map(newArray);
            // eslint-disable-next-line no-unused-vars
            for (let [key, t] of map.entries()) {
                const result = [];
                t.values.forEach((el) => {
                    result.push({label: el.label, enumValue: el.value});
                });
                map[key] = result;
            }
            return Promise.resolve(map);
        });
    }

    getEnumListWithDescription(enumName, translate) {
        return this.fetch(`${this.domain}/${this.path}/list/${enumName}`, {
            method: 'GET',
        }).then((res) => {
            const result = [];
            if (res && translate) {
                res.forEach((element) => {
                    result.push({
                        label: translate(`${enumName}.${element}`),
                        enumValue: element,
                        description: translate(`${enumName}.${element}descr`),
                    });
                });
            }
            return Promise.resolve(result);
        });
    }

    getEnumLabel(enumName, enumValue) {
        return this.fetch(`${this.domain}/${this.path}/label/${enumName}/${enumValue}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
